import React from 'react'
import PermissionListTable from './PermissionListTable'

const PermissionList = () => {
    return (
        <div className="container-fluid admin-module-page admin-rbac-page py-4">
            <div className="admin-page-header d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
                <div>
                    <span className="admin-page-kicker">Access Control</span>
                    <h3 className="admin-page-title fw-bold mb-1">Permission List</h3>
                    <p className="admin-page-description mb-0">
                        Review, create, and maintain permissions.
                    </p>
                </div>
            </div>

            <div className="card admin-surface-card">
                <div className="card-body admin-surface-body">
                    <PermissionListTable />
                </div>
            </div>
        </div>
    )
}

export default PermissionList